import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import { getImportErrorCopy } from '@/inventory/pages/InventoryPage/ImportInventoryDataDrawer/ImportResultModal/helpers'

import ImportErrorRowsDetail from './ImportErrorRowsDetail/ImportErrorRowsDetail'
import * as Styles from './styles'

const ImportErrorRow = ({ error }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [expanded, setExpanded] = useState(false)
  const CaretIcon = expanded ? CaretUpIcon : CaretDownIcon

  const handleToggle = () => setExpanded(expanded => !expanded)

  return (
    <Styles.Row>
      <Styles.ToggleButton type="button" onClick={handleToggle} aria-expanded={expanded}>
        <Text type="bodyMRegular">{t(getImportErrorCopy(error.error_type))}</Text>
        <Styles.Count>
          <Text type="bodyMBold" color={theme.colors.warning.onSurface}>
            <FormatNumber>{error.count}</FormatNumber>
          </Text>
          <CaretIcon size={16} color={theme.colors.text.muted} />
        </Styles.Count>
      </Styles.ToggleButton>
      {expanded && <ImportErrorRowsDetail column={error.column} rows={error.rows} />}
    </Styles.Row>
  )
}

export default ImportErrorRow
